import { useContext } from 'react';
import ApartmentOutlinedIcon from '@mui/icons-material/ApartmentOutlined';
import { cx } from '@emotion/css';
import { BodyMedium, BodySmallMidEmphasis, TitleSmallEmphasized } from '@/design-system';
import colors from '@/theme/colors';
import { FollowButton } from '@/pages/OrgProfile/components/FollowButton/FollowButton';
import { FlyerOrganization } from '@/graphql/types';
import { AccessibleDivButton } from '@/components';
import AuthenticationContext from '@/context/AuthenticationContext';
import styles from './ProvidedByCommunity.styles';

interface Props {
  org: FlyerOrganization;
  goToOrgProfile: () => void;
}

export const ProvidedByCommunity: React.FC<Props> = ({ org, goToOrgProfile }) => {
  const { isAuthenticated } = useContext(AuthenticationContext);

  return (
    <div className={styles.container}>
      <TitleSmallEmphasized>Provided By</TitleSmallEmphasized>
      <div className={styles.orgNameContainer}>
        <div className={styles.orgNameWrapper}>
          <div className={styles.icon}>
            <ApartmentOutlinedIcon sx={{ fontSize: 18 }} />
          </div>
          <div data-testid="orgProfileContainer">
            {org.approvedFlyerCount > 0 && isAuthenticated ? (
              <AccessibleDivButton onClick={goToOrgProfile}>
                <TitleSmallEmphasized
                  color={colors.jungle}
                  className={cx(styles.orgName, styles.activeOrgName)}
                  data-testid="orgName"
                >
                  {org.name}
                </TitleSmallEmphasized>
              </AccessibleDivButton>
            ) : (
              <TitleSmallEmphasized
                className={styles.orgName}
                color={colors.prussian}
                data-testid="orgName"
              >
                {org.name}
              </TitleSmallEmphasized>
            )}
            <div>
              <BodySmallMidEmphasis color={colors.slate}>
                Community Organization
              </BodySmallMidEmphasis>
            </div>
          </div>
        </div>
        {isAuthenticated && (
          <FollowButton
            orgId={Number(org.orgId)}
            orgName={org.name}
            isFollowingInitial={org.isFollowing}
          />
        )}
      </div>

      {org.childEnrichmentStatement && (
        <div className={styles.disclaimer}>
          <BodyMedium color={colors.midnight} data-testid="orgDescription">
            {org.childEnrichmentStatement}
          </BodyMedium>
        </div>
      )}
    </div>
  );
};
